// extracted by mini-css-extract-plugin
module.exports = {"legend":"Nd+Y+","required":"pb9Pl"};